import { render } from "./DefectsPage.vue?vue&type=template&id=29f268b9"
import script from "./DefectsPage.vue?vue&type=script&lang=js"
export * from "./DefectsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__